import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ToolsService } from '../tools/tools.service';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Auth, user } from '@angular/fire/auth';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class BaseclientService {

  urlBase: string = environment.apiUrl;
  currentIdWebshop = null;

  user$: Observable<any>;
  constructor(
    private http: HttpClient,
    private af: AngularFireAuth,
    private tools: ToolsService,
    private auth: Auth
  ) {
    this.user$ = user(this.auth);
  }

  postBase(endurl: string, param?: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.getIdToken().then(token => {

        this.http.post(this.urlBase + endurl, param, {
          headers: {
            "Content-Type": "application/json",
            "Authorization": token
          }
        }).toPromise().then(data => {
          resolve(data);
        }).catch(err => {
          reject(err);
        });
      }).catch(err => {
        reject(err);
      })
    })
  }

  getBase(endurl: string, params?: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.getIdToken().then(token => {
        this.http.get(this.urlBase + endurl, {
          params: params,
          headers: {
            "Content-Type": "application/json",
            "Authorization": token
          }
        }).toPromise().then(data => {
          resolve(data);
        }).catch(err => {
          reject(err);
        })
      }).catch(err => { reject(err); })
    });
  }

  /**
   * Token Firebase client connecté
   */
  getIdToken(): Promise<any> {
    return new Promise((resolve) => {
      this.af.currentUser.then(function (user: any) {
        if (user) {
          user.getIdToken(false).then(function (idToken: any) {
            resolve(idToken);
          });
        }
        else {
          resolve("invalid_token");
        }
      });
    });
  }

  /**
   * Envoi d'une requete à l'API Webshop
   * @param endurl
   * @param param
   */
  postBaseApi(endurl: string, param?: any): Promise<any> {
    // if (endurl === 'stocks') {
    //   console.log("baseclient.service - postBaseApi - endurl : ", endurl)
    //   console.log("baseclient.service - postBaseApi - param : ", param)
    // }
    return new Promise((resolve, reject) => {
      param = !param ? {} : param;
      const pos: any = this.tools.getStor("point_of_sale");
      // if (endurl === 'stocks')
      //   console.log("baseclient.service - postBaseApi - pos : ", pos)
      // param.id_webshop = ((param && param.id_webshop) ? (param.id_webshop) : (pos ? pos.id_webshop : null));
      if (!param.id_webshop) {
        if (pos) {
          if (pos.id_webshop)
            param.id_webshop = pos.id_webshop;
          else if (pos.idWebshop)
            param.id_webshop = pos.idWebshop;
        }
      }
      // if (endurl === 'stocks')
      //   console.log("baseclient.service - postBaseApi - param 2: ", param)

      // Webshop en cours, stockage pour rappel
      if (param.id_webshop != null) {
        this.currentIdWebshop = param.id_webshop;
      }
      // if (endurl === 'stocks')
      //   console.log("baseclient.service - postBaseApi - param 3: ", param)

      this.http.post(this.urlBase + endurl, param, {
        headers: {
          "Content-Type": "application/json",
        }
      }).toPromise().then(data => {
        resolve(data);
      }).catch(err => {
        reject(err);
      });
    })
  }
}
